import { Box, styled } from '@mui/material';

export const StyledFilterComponentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2)
}));

export const StyledFilterFieldBox = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  minWidth: theme.spacing(35)
}));
